
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import BasicInputs from "./BasicInputs";
import AdvancedInputs from "./AdvancedInputs";
import ClosingCostsInputs from "./ClosingCostsInputs";
import { MortgageData } from "../CalculatorTabs";
import { AutoCalculateOptions } from "../utils/types";

interface TabsContentProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
  setAutoCalculate: React.Dispatch<React.SetStateAction<AutoCalculateOptions>>;
  states: {id: string, name: string, abbreviation: string}[];
  cities: {id: string, name: string}[];
  calculatorHandlers: {
    handleHomePriceChange: (value: number) => void;
    handleInterestRateChange: (value: number) => void;
    handleLoanTermChange: (value: number) => void;
    handleDownPaymentChange: (value: number) => void;
    handleLoanTypeChange: (value: any) => void;
    handleZipCodeChange: (value: string) => void;
    handleIsVeteranChange: (value: boolean) => void;
  };
}

const CalculatorTabsContent: React.FC<TabsContentProps> = ({
  mortgageData,
  setMortgageData,
  autoCalculate,
  setAutoCalculate,
  states,
  cities,
  calculatorHandlers
}) => {
  return (
    <Tabs defaultValue="basic" className="w-full">
      <TabsList className="grid grid-cols-3 w-full mb-4">
        <TabsTrigger value="basic">Basic</TabsTrigger>
        <TabsTrigger value="advanced">Advanced</TabsTrigger>
        <TabsTrigger value="closing">Closing Costs</TabsTrigger>
      </TabsList>
      
      {/* Basic Inputs */}
      <TabsContent value="basic">
        <BasicInputs 
          mortgageData={mortgageData} 
          setMortgageData={setMortgageData} 
          autoCalculate={autoCalculate}
          calculatorHandlers={calculatorHandlers}
        />
      </TabsContent>
      
      {/* Advanced Inputs */}
      <TabsContent value="advanced">
        <AdvancedInputs
          mortgageData={mortgageData}
          setMortgageData={setMortgageData}
          autoCalculate={autoCalculate}
          setAutoCalculate={setAutoCalculate}
          states={states}
          cities={cities}
        />
      </TabsContent>
      
      {/* Closing Costs Tab */}
      <TabsContent value="closing">
        <ClosingCostsInputs
          mortgageData={mortgageData}
          setMortgageData={setMortgageData}
          autoCalculate={autoCalculate}
          setAutoCalculate={setAutoCalculate}
        />
      </TabsContent>
    </Tabs>
  );
};

export default CalculatorTabsContent;
